import { createStore } from 'redux'
import fiday from './reducers'

let store = createStore(fiday)
export default store



// WEBPACK FOOTER //
// ./store.js